<template>
    <div class="item relative" :class="{ small: small }">
        <div class="description">
        <img class="image" :src="image" alt="" />
        <template v-if="!small&&!fact">
            <v-btn
            class="mx-2 absolute"
            fab
            dark
            x-small
            color="red"
            @click="delete_prod(item._id)"
            >
            <v-icon dark> mdi-minus </v-icon>
            </v-btn>
            <v-btn  class="mx-2 absolute-left"
              fab
              dark
              x-small
              color="orange"
              @click="dialog = true"
            >
            
              <v-icon dark>mdi-format-align-justify </v-icon>
            </v-btn>
        </template>d
        <div class="d-flex justify-between">
          <div class="name">{{ item.name }} - {{item.ratio}}&nbsp;₽</div>
        </div>
        </div>
        <template v-if="small">
        <div class="inputs">
            <div class="input">
            <div class="input-group">
                <template v-if="item.fact >= item.plan">
                <v-text-field
                    label="Факт"
                    :value="item.fact"
                    class="v-text-field--green"
                ></v-text-field>
                </template>
                <template v-else>
                <v-text-field
                    label="Факт"
                    :value="item.fact"
                    class="v-text-field--red"
                    :disabled="input"
                ></v-text-field>
                </template>
            </div>
            </div>
            <div class="input">
            <v-text-field
                label="План"
                disabled
                :value="item.plan"
                class="v-text-field--green"
            ></v-text-field>
            </div>
        </div>
        </template>
        <template v-if="plan">
        <div class="x">x</div>
        <div class="input">
            <v-text-field
                v-model="item.plan"
                label="План"
                @change="update_plan(item)"
            ></v-text-field>
        </div>
        </template>
        <template v-if="fact">
            <div class="accessories">
                <AccessoryView
                    v-for="(accessory, index) in item.accessories"
                    :key="index"
                    :item="accessory"
                    :current_product_id="item._id"
                    :group_id="group_id"
                    :small="small"
                    :fact="fact"
                    :_id="_id"
                    :status="status"
                    :brigade_count_users="brigade_count_users"
                    :brigade_selected="brigade_selected"
                />
            </div>
        </template>
        <template v-if="small">
            <div class="accessories">
                <AccessoryView
                    v-for="accessory in item.accessories"
                    :key="accessory._id"
                    :item="accessory"
                    :current_product_id="item._id"
                    :group_id="group_id"
                    :small="small"
                    :fact="fact"
                    :_id="_id"
                    :status="status"
                    :input="input"
                    :brigade_count_users="brigade_count_users"
                    :brigade_selected="brigade_selected"
                />
            </div>
        </template>

        <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="500"
          >
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Подгруппа продукта {{ item.name }}
              </v-card-title>

              <v-card-text>
               <v-container>
                 <v-select :items="get_sub_groups" label="Подгруппа" v-model="local_sub_group.sub_group" item-text="name" item-value="name"></v-select>
               </v-container>
              </v-card-text>

  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="warning"
                  text
                  @click="update_product_sub_group"
                >
                  Сохранить
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="dialog = false"
                >
                  Закрыть
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AccessoryView from "@/components/accessories/AccessoryView.vue";

export default {
    name: "Product",
    props: ["item", "type", "plan", "group_id", "fact", "small", "status", "_id", 'input', 'brigade_count_users', 'brigade_selected'],
     data() {
        return {
            local_sub_group: JSON.parse(JSON.stringify(this.item)),
            select_on: false,
            dialog: false,
        }
    },
    components: {
        AccessoryView,
    },
    computed: {
        image() {
            return `/images/products/${this.item.image}`;
        },
        sub_group() {
          console.log(this.item);
        },
        ...mapGetters(["get_sub_groups"]),
    },
    methods: {
        ...mapActions(["update_plan_product_quantity", "delete_product", 'update_sub_group']),
        update_plan(product) {
            this.update_plan_product_quantity({ product, group_id: this.group_id });
        },
        delete_prod(_id) {
            this.delete_product({ _id })
                .then(() => {})
                .catch(() => {});
        },
        update_product_sub_group() {
            
          this.update_sub_group({ product_id :this.local_sub_group._id, sub_group: this.local_sub_group.sub_group}).then(res => {
            console.log(res);
            this.dialog = false
          });
        }
    },
};
</script>

<style scoped>
.item {
  color: rgba(0, 0, 0, 0.6);
  background-color: #fff;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  border-radius: 4px;
  font: 15px/24px "Open Sans", Arial, sans-serif;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin:15px;
}

.image {
  object-fit: contain;
  width: 160px;
  height: 160px;
}

.name {
  font-size: 0.933em;
  line-height: 1.501em;
  text-transform: uppercase;
  transition: color ease-out 20ms;
  color: #333;
}

.justify-between {
  justify-content: space-between;
}

.name:hover {
  color: #f26213;
}

.x {
  font-size: 20px;
  margin: 0 8px;
}

.v-text-field >>> input {
  font-size: 32px;
  width: 100px;
  text-align: center;
}

.input-group {
  display: flex;
  align-items: center;
}

.accessories {
  display: flex;
}
.item.small .description {
  margin-right: 10px;
}

.item.small .image {
  width: 100px;
  height: 100px;
}

.item.small .name {
  font-size: 20px;
}

.item.small .v-text-field >>> input {
  font-size: 26px;
  width: 80px;
  text-align: center;
}

.item.small .v-text-field--green >>> input {
  color: green;
}

.item.small .v-text-field--red >>> input {
  color: red;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
  top: 5px;
  right: 0px;
}

.absolute-left {
  position: absolute;
  top: 5px;
  left: 0px;
}

</style>